import React from 'react';
import { MultiCombo } from 'fw/forms';
import * as API from 'modules/app/API'

class NaicsCategoryCodeMultiCombo extends React.Component {

	constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

	completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

    componentDidMount = () => {
        this._isMounted = true;

        API.Certification.get('/query/getNAICSCodeCategory', {},
            {
                success: (r) => {
                    this._isMounted && this.setState({
                        items: r.data.items.map((item) => { return { label: item.description, value: item.code } })
                    });
                }
            }, { block: false });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <MultiCombo 
                {...this.props}
                placeholder={this.props.placeholder ? this.props.placeholder : "NAICS Code(s)..."}
                items={this.state.items}
                searchable={true}
                ref={(c) => { this._ctrl = c }} />
        )
    }
}

export default NaicsCategoryCodeMultiCombo;

// Mark this as a form component
NaicsCategoryCodeMultiCombo.defaultProps = {
	formControl: true,
	managed: false,
	placeholder: "Search..."
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/naicsCategoryCodeMultiCombo/NaicsCategoryCodeMultiCombo.js